import * as React from 'react'

function SvgPlayerDefaltScreen(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 24 24" fill="currentColor" {...props}>
      <path
        d="M11.023 14.21l.008.118.01 6.331a.882.882 0 01-.762.874l-.12.008h-.262a.88.88 0 01-.871-.76l-.008-.12-.006-3.802-3.754 3.755a.88.88 0 01-1.163.074l-.083-.074-.187-.187a.88.88 0 01-.073-1.162l.073-.083 3.873-3.873-4.446-.005a.88.88 0 01-.872-.76l-.008-.12v-.264l.008-.12a.88.88 0 01.754-.751l.12-.008 6.33.007c.188 0 .361.06.504.16l.064.001a.88.88 0 01.87.76zm8.107-9.976a.88.88 0 01.073 1.162l-.073.083-3.873 3.874 4.687.004a.88.88 0 01.87.76l.01.12v.264l-.009.12a.881.881 0 01-.754.752l-.12.007-6.33-.007a.877.877 0 01-.504-.159l-.063-.002a.88.88 0 01-.872-.76l-.008-.119-.01-6.33a.883.883 0 01.763-.875l.12-.008h.261a.88.88 0 01.871.76l.008.12.006 3.562 3.515-3.515a.88.88 0 011.162-.074l.083.074.187.187z"
        fillRule="evenodd"
      />
    </svg>
  )
}

export default SvgPlayerDefaltScreen
